import type { KeyboardEvent } from 'react';

interface DillInputProps {
  value: string;
  onChange: (v: string) => void;
  onBlur?: (v: string) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  error?: string;
  type?: string;
  disabled?: boolean;
}

export const DillInput = ({
  value,
  onChange,
  onBlur,
  onKeyDown,
  placeholder,
  error,
  type = 'text',
  disabled,
}: DillInputProps) => (
  <input
    type={type}
    value={value}
    placeholder={placeholder}
    onChange={(e) => onChange(e.target.value)}
    onBlur={onBlur ? (e) => onBlur(e.target.value) : undefined}
    onKeyDown={onKeyDown}
    disabled={disabled}
    className={`h-9 px-3 text-sm rounded-lg border w-full outline-none transition-all
      ${
        disabled
          ? 'border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed'
          : error
          ? 'border-red-400 bg-red-50 text-gray-900'
          : 'border-gray-300 bg-white text-gray-900 focus:border-blue-400 focus:ring-2 focus:ring-blue-50'
      }`}
  />
);
